import React from "react";
import { Skeleton } from "@mui/material";

export function AuthFormSkeleton() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 w-full min-h-screen">
      <div className="hidden lg:block w-full h-screen overflow-hidden">
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          animation="wave"
        />
      </div>
      <div className="flex items-center justify-center p-8">
        <div style={{ width: "100%", maxWidth: "360px" }}>
          <Skeleton
            variant="text"
            width="60%"
            height={36}
            animation="wave"
            style={{ marginBottom: "24px" }}
          />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={48}
            animation="wave"
            style={{ borderRadius: 8, marginBottom: "16px" }}
          />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={48}
            animation="wave"
            style={{ borderRadius: 8, marginBottom: "24px" }}
          />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={44}
            animation="wave"
            style={{ borderRadius: 24, marginBottom: "20px" }}
          />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={44}
            animation="wave"
            style={{ borderRadius: 8 }}
          />
        </div>
      </div>
    </div>
  );
}
